import { c as _c } from "react/compiler-runtime";
import { components } from '../apiV4';
import { TrustedHtml } from './trusted_html';
import { decode } from 'html-entities';
import { formatAmount } from '../helpers/format_amount';
import type { ReactNode, MouseEvent } from 'react';
export type Project = components['schemas']['ProjectResult'] | (components['schemas']['SearchResult'] & { [K in Exclude<keyof components['schemas']['ProjectResult'], keyof components['schemas']['SearchResult']>]?: undefined });
export type ProjectTeaserProps = {
  locale?: string;
  project: Project;
  onClick?: (event: MouseEvent, project: Project) => void;
  showDescription?: boolean;
  bottomContent?: ReactNode;
  href?: string;
  showCarrierName?: boolean;
  openInTab?: boolean;
  className?: string;
  font?: string;
  textColor?: string;
  progressbarColor?: string;
  progressbarBackgroundColor?: string;
  extraHeight?: number;
  children?: React.ReactNode;
};
export const ProjectTeaser: React.FC<ProjectTeaserProps> = t0 => {
  const $ = _c(67);
  const {
    project,
    locale: t1,
    href: href_,
    onClick,
    className,
    showDescription,
    openInTab,
    bottomContent,
    children,
    showCarrierName
  } = t0;
  const locale = t1 === undefined ? document.documentElement.lang || "de" : t1;
  let t2;
  if ($[0] !== locale || $[1] !== project.open_amount_in_cents) {
    t2 = formatAmount({
      cents: project.open_amount_in_cents,
      locale
    });
    $[0] = locale;
    $[1] = project.open_amount_in_cents;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const openAmount = t2;
  let t3;
  if ($[3] !== locale || $[4] !== project.donations_count) {
    t3 = new Intl.NumberFormat(locale).format(project.donations_count);
    $[3] = locale;
    $[4] = project.donations_count;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const donationsCount = t3;
  const openAmountCaption = locale === "de" ? "fehlen noch" : "still needed";
  const donationsCountCaption = locale === "de" ? "Spenden" : "donations";
  const href = href_ || project.links.find(_temp)?.href;
  let t4;
  if ($[6] !== project.profile_picture?.links) {
    t4 = project.profile_picture?.links.find(_temp2)?.href;
    $[6] = project.profile_picture?.links;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const projectImageUrl = t4;
  let t5;
  if ($[8] !== project.carrier?.picture?.links) {
    t5 = project.carrier?.picture?.links.find(_temp3)?.href;
    $[8] = project.carrier?.picture?.links;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const orgaImageUrl = t5;
  let t6;
  if ($[10] !== onClick || $[11] !== project) {
    t6 = event => {
      onClick?.(event, project);
    };
    $[10] = onClick;
    $[11] = project;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleClick = t6;
  let t7;
  if ($[13] !== project.title) {
    t7 = project.title ? decode(project.title) : "";
    $[13] = project.title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = `donatable-teaser ${className ?? ""} ${showDescription ? "donatable-teaser--with-description" : ""} ${bottomContent ? "donatable-teaser--with-bottom-content" : ""}`;
  const t9 = openInTab ? "_blank" : "_parent";
  const t10 = `url(${projectImageUrl})`;
  let t11;
  if ($[15] !== t10) {
    t11 = {
      backgroundImage: t10
    };
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== project.title) {
    t12 = project.title ? decode(project.title) : "";
    $[17] = project.title;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <div className="donatable-teaser--profile-picture" style={t11} title={t12} />;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== project.title) {
    t14 = <TrustedHtml as="h2" className="donatable-teaser--title" value={project.title} />;
    $[22] = project.title;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== project.description || $[25] !== showDescription) {
    t15 = showDescription && <TrustedHtml className="donatable-teaser--description" as="div" value={project.description} />;
    $[24] = project.description;
    $[25] = showDescription;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== project.city) {
    t16 = project.city && <><span>{project.city}</span>,{" "}</>;
    $[27] = project.city;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== project.country || $[30] !== t16) {
    t17 = <div>{t16}{project.country}</div>;
    $[29] = project.country;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== donationsCount || $[33] !== donationsCountCaption || $[34] !== project.carrier?.name || $[35] !== showCarrierName) {
    t18 = <div>{showCarrierName ? <span>{project.carrier?.name}</span> : <><span>{donationsCount}</span> {donationsCountCaption}</>}</div>;
    $[32] = donationsCount;
    $[33] = donationsCountCaption;
    $[34] = project.carrier?.name;
    $[35] = showCarrierName;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== openAmount) {
    t19 = <span>{openAmount}</span>;
    $[37] = openAmount;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== openAmountCaption || $[40] !== t19) {
    t20 = <div>{t19} {openAmountCaption}</div>;
    $[39] = openAmountCaption;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t17 || $[43] !== t18 || $[44] !== t20) {
    t21 = <div className="donatable-teaser--factlist">{t17}{t18}{t20}</div>;
    $[42] = t17;
    $[43] = t18;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  const t22 = project.carrier?.name;
  let t23;
  if ($[46] !== orgaImageUrl || $[47] !== t22) {
    t23 = <img src={orgaImageUrl} alt={t22} className="donatable-teaser--carrier-logo" />;
    $[46] = orgaImageUrl;
    $[47] = t22;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t21 || $[50] !== t23) {
    t24 = <div className="donatable-teaser--divider">{t21}{t23}</div>;
    $[49] = t21;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  const t25 = `${project.progress_percentage}%`;
  let t26;
  if ($[52] !== t25) {
    t26 = <div className="donatable-teaser--progress"><div className="donatable-teaser--progress-bar" style={{
        width: t25
      }} /></div>;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== bottomContent || $[55] !== children || $[56] !== handleClick || $[57] !== href || $[58] !== t13 || $[59] !== t14 || $[60] !== t15 || $[61] !== t24 || $[62] !== t26 || $[63] !== t7 || $[64] !== t8 || $[65] !== t9) {
    t27 = <a title={t7} onClick={handleClick} className={t8} href={href} target={t9} rel="noreferrer">{children}{t13}{t14}{t15}{t24}{t26}{bottomContent}</a>;
    $[54] = bottomContent;
    $[55] = children;
    $[56] = handleClick;
    $[57] = href;
    $[58] = t13;
    $[59] = t14;
    $[60] = t15;
    $[61] = t24;
    $[62] = t26;
    $[63] = t7;
    $[64] = t8;
    $[65] = t9;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  return t27;
};
function _temp(link) {
  return link.rel === "platform";
}
function _temp2(link_0) {
  return link_0.rel === "fill_410x214";
}
function _temp3(link_1) {
  return link_1.rel === "fill_100x100";
}